import { render, staticRenderFns } from "./addHomeSales.vue?vue&type=template&id=6845480c&scoped=true"
import script from "./addHomeSales.vue?vue&type=script&lang=js"
export * from "./addHomeSales.vue?vue&type=script&lang=js"
import style0 from "./addHomeSales.vue?vue&type=style&index=0&id=6845480c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6845480c",
  null
  
)

export default component.exports